import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { StageDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";
import {
  AXIS_STYLES,
  GRID_STYLES,
} from "src/components/Referral-partner/Analytics/styles/chart.styles";

const RoundedBar = ({ fill, x, y, width, height }: any) => {
  const radius = Math.abs(height) / 2;

  // Handle negative values
  const adjustedY = height < 0 ? y + height : y;
  const adjustedHeight = Math.abs(height);

  // Ensure width is at least 2 * radius to prevent negative width
  const adjustedWidth = Math.max(width, radius * 2);

  return (
    <g>
      {/* Main rectangle body */}
      <rect
        x={x}
        y={adjustedY}
        width={Math.max(0, adjustedWidth - radius)} // Prevent negative width
        height={adjustedHeight}
        fill={fill}
      />
      {/* Rounded end */}
      <circle cx={x + adjustedWidth - radius} cy={adjustedY + radius} r={radius} fill={fill} />
    </g>
  );
};

interface ConversionFunnelProps {
  data: StageDataPoint[];
}

const ConversionFunnel = (props: ConversionFunnelProps) => {
  const { data } = props;
  return (
    <ResponsiveContainer id="conversion-signups-chart" height="80%" width="95%">
      <BarChart data={data} barSize={20} layout="vertical" margin={{ top: 20, left: 10 }}>
        <CartesianGrid vertical={false} {...GRID_STYLES} />
        <XAxis type="number" {...AXIS_STYLES} />
        <YAxis dataKey="stage" type="category" {...AXIS_STYLES} />
        <Tooltip content={<AnalyticsTooltip />} />
        <Bar dataKey="customers" fill="#a1a1ea" shape={<RoundedBar />} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConversionFunnel;
